import React from "react";
import { dispatch } from '@rematch/core';
import { Card, Icon, Image } from 'semantic-ui-react'
import camelCase from 'lodash/camelCase';
import { withRouter } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import FilterActivityModal from '../../Drive/modals/FilterActivity';
import Board from './../../Drive/Tree/ActivityTreeView';
import LoadingComponent from '../../../../common/LoadingComponent';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import ArrangementPane from './ArrangementPane'
import ActivityCard from '../../Drive/cards/ActivityCardNew';
import aciveFilterIcon from './../../../../../images/grafix-icon/icon-check-circle.svg';
import ChangeAccountableConfirmationModal from '../../Drive/modals/ChangeAccountableConfirmationModal';
import _ from 'lodash';
let treeArray;
class Team extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            associatedCommunity: null,
            managers: [],
            members: [],
            newAssignee: null,
        }
    }

    async getTeamTreeData(communities) {
        let setColor;
        treeArray = communities;
        let teamViewMap = new Map();
        treeArray && treeArray.map((tree) => {
            teamViewMap.set(tree._id, tree);
            if (typeof tree === 'object') {
                tree.lanes = [];
                tree.lanes = tree.communities.length > 0 ? tree.communities : [];
                tree.lanes.map((lane) => {
                    teamViewMap.set(lane._id, lane);
                    lane.title = lane.name;
                    lane.cards = lane.activities ? lane.activities : [];
                    lane.label = lane.cards.length > 0 ? lane.cards.length : '0';
                    lane.onTracklabel = lane.cards.length > 0 ? lane.cards.filter((i) => { i.runStatus === 1 && i.isDelayedToStart !== true && i.isDelayedToEnd !== true && i.issueFlag !== true }).length : 0;
                    lane.cautionlabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.isDelayedToEnd === true && i.runStatus !== 2 }).length : 0;
                    lane.issuelabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.issueFlag === true }).length : 0;
                    lane.completedlabel = lane.cards.length > 0 ? lane.cards.filter((i) => { return i.runStatus === 2 }).length : 0;
                    lane.cards.map((card) => {
                        teamViewMap.set(card._id, card);
                        card.title = card.name;
                    })
                })
                if (tree.activities && tree.activities.length > 0) {

                    tree.activities.map((card) => {
                        teamViewMap.set(card._id, card);
                        card.title = card.name
                    })
                    let lane = {
                        title: "Others",
                        communityTagColor: setColor,
                        cards: tree.activities,
                        isDummy: true
                    };
                    tree.lanes.push(lane)
                }
            }

        })
        dispatch.initiatives.setTeamViewMap(teamViewMap);
    }

    async componentDidMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        let objValidation = Object.entries(this.props.selectedDataById).length === 0 && this.props.selectedDataById.constructor === Object;

        if (objValidation) {
            await dispatch.initiatives.getActiveInitiativeDetailsById(this.props.match.params.initiativeId);
        }

        dispatch.initiatives.setTabName("Teams");

        let payload = {
            organizationId: this.props.match.params.organizationId,
            initiativeId: this.props.match.params.initiativeId
        }
        dispatch.initiatives.getAssociatedTeam(payload)
        if (!this.props.selectedDataById.communitiesFetched) {
            await dispatch.initiatives.getCommunityWiseActivities(this.props.match.params.initiativeId);
        }

        if (this.props.match.params.organizationId && !this.props.selectedDataById.activityNodes) {
            if (this.props.selectedDataById && this.props.selectedDataById.category) {
                dispatch.initiatives.getPublishedContentDataAsync({ organizationId: this.props.match.params.organizationId, category: this.props.selectedDataById.category });
            }
            // dispatch.initiatives.getAllActivities(payload);
        }

        this.getTeamTreeData(this.props.selectedDataById.communities);
    }

    async componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.props.selectedDataById.communities, nextProps.selectedDataById.communities)) {
            await this.getTeamTreeData(nextProps.selectedDataById.communities);
        }
        if (!nextProps.selectedDataById.communitiesFetched) {
            await dispatch.initiatives.getCommunityWiseActivities(this.props.match.params.initiativeId);
        }
        if (nextProps.match.params.organizationId && !nextProps.selectedDataById.activityNodes) {
            if (nextProps.selectedDataById && nextProps.selectedDataById.category) {
                dispatch.initiatives.getPublishedContentDataAsync({ organizationId: nextProps.match.params.organizationId, category: this.props.selectedDataById.category });
            }
        }
    }

    filterClick = (open) => {
        this.setState({
            prevAdvancedFilterProperties: Object.assign({}, this.props.advancedFilterProperties),
            prevRaciFilterProperties: Object.assign({}, this.props.raciFilterProperties)
        })
        this.setState({ open: open })
    }

    closeFilterModal = () => {
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.state.prevAdvancedFilterProperties));
        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.state.prevRaciFilterProperties));
        this.setState({ open: false })
    }

    setManagers = (value) => {
        this.setState({ managers: value })
    }
    setMembers = (value) => {
        this.setState({ members: value })
    }
    setAssignee = (value) => {
        this.setState({ newAssignee: value })
    }
    setAssociatedCommunity = (value) => {
        this.setState({ associatedCommunity: value })
    }
    setChangeAccountableConfirmationModalOpen = () => {
        this.setState({ openChangeAccountableConfirmationModal: true })
    }
    closeChangeAccountConfirmationModal = () => {
        this.setState({ openChangeAccountableConfirmationModal: false })
    }
    render() {

        /**
         * Sorting the activities data to show the activities on top which we can start (start button) 
         */
        if (treeArray && treeArray.length > 0) {
            for (let i = 0; i < treeArray.length; i++) {
                for (let j = 0; j < treeArray[i].lanes.length; j++) {
                    if (treeArray[i].lanes[j].activities && treeArray[i].lanes[j].activities.length > 0) {
                        treeArray[i].lanes[j].activities.sort(function (a, b) {
                            if (a.runStatus > b.runStatus) return -1;
                            if (a.runStatus < b.runStatus) return 1;
                            return 0;
                        });
                    }
                }
            }
        }


        let height = this.props.componentDesignerDimension;
        const setHeight = (height.windowHeight - height.height) - 160;


        const teamStyle = {};

        if (!isNaN(height)) {
            teamStyle.height = setHeight
        }



        let isFilterApplied = (this.props.raciFilterProperties &&
            (this.props.raciFilterProperties.accountable ||
                this.props.raciFilterProperties.responsible ||
                this.props.raciFilterProperties.consulted ||
                this.props.raciFilterProperties.informed)) ||
            (this.props.advancedFilterProperties &&
                (this.props.advancedFilterProperties.roles.length > 0 ||
                    this.props.advancedFilterProperties.stateActiveChecked ||
                    this.props.advancedFilterProperties.stateOnHoldChecked ||
                    this.props.advancedFilterProperties.statusNotStartedChecked ||
                    this.props.advancedFilterProperties.statusCompletedChecked ||
                    this.props.advancedFilterProperties.statusIssueChecked ||
                    this.props.advancedFilterProperties.statusInProgressChecked ||
                    this.props.advancedFilterProperties.statusDelayedChecked ||
                    this.props.advancedFilterProperties.showAllRoles ||
                    this.props.advancedFilterProperties.serarchedRolesAvailable ||
                    this.props.advancedFilterProperties.selectedUsers.length > 0)) ? true
            : false

        let windowDimension = this.props.componentDesignerDimension;
        return (
            <div ref={this.parentRef}
                className="containerBox overflow-hide"
                style={{ width: windowDimension.width ? (windowDimension.width - 40) : 300 }}
            >
                <ArrangementPane {...this.props} />
                <BreadCrumbs {...this.props} />
                {
                    this.props.loadingCommunityWiseActivities ? <LoadingComponent active={this.props.loadingCommunityWiseActivities} message="Fetching Team wise activities" /> :
                        <div className="initiative_overall_progress ">
                            <Card className="progressDetail w_100">
                                <Card.Content className="header_content">
                                    <Card.Header>
                                        <strong className="pad_10">
                                            Teams
                                        </strong>
                                        {
                                            isFilterApplied ?
                                                <div className='pull-right pad_12 activeFilter' >
                                                    <Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right" />
                                                    <Image size='mini' src={aciveFilterIcon} onClick={() => this.filterClick(true)} className="pull-right " style={{ position: "absolute", right: '8px', top: '8px', width: '10px', color: 'white' }} />
                                                </div> :
                                                <div className='pull-right pad_12' >
                                                    <Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right" />
                                                </div>
                                        }
                                    </Card.Header>
                                </Card.Content>
                                <Card.Content className="Detailed_content" >
                                    <div id="teamView" className="activityTable " >
                                        <div
                                            ref={this.parentRef}
                                            className="mainBox overflow-hide"
                                            style={{ height: (height.windowHeight - height.height) - 170 }}>
                                            {treeArray && treeArray.length && treeArray.map(function (tree, index) {

                                                return (<div id={camelCase("board" + index)} className="childBox" key={index} >
                                                    <div className={` phaseHeading `} >

                                                        <ActivityCard
                                                            type="phase"
                                                            activityData={tree}
                                                            activeTab={this.props.activeTab}
                                                            selectedActivityData={this.props.selectedActivityData}
                                                            activityRACIUsers={this.props.activityRACIUsers}
                                                            selectedDataById={this.props.selectedDataById}
                                                            selectedOrganisation={this.props.selectedOrganisation}
                                                            // index={index}
                                                            user={this.props.user}
                                                            {...this.props}
                                                        />
                                                    </div>
                                                    <Board data={tree}
                                                        setManagers={this.setManagers}
                                                        setMembers={this.setMembers}
                                                        setAssignee={this.setAssignee}
                                                        setAssociatedCommunity={this.setAssociatedCommunity}
                                                        setChangeAccountableConfirmationModalOpen={this.setChangeAccountableConfirmationModalOpen}
                                                        {...this.props}
                                                        page="Team"
                                                        boardIndex={index} />
                                                </div>
                                                );
                                            }, this)}
                                        </div>
                                    </div>
                                </Card.Content>
                                <FilterActivityModal
                                    initiativeId={this.props.match.params.initiativeId}
                                    associatedTeams={this.props.associatedTeams}
                                    raciFilterProperties={this.props.raciFilterProperties}
                                    advancedFilterProperties={this.props.advancedFilterProperties}
                                    accountUserId={this.props.user._id}
                                    activeTab={this.props.activeTab}
                                    open={this.state.open}
                                    closeFilterModal={this.closeFilterModal}
                                    filterClick={this.filterClick}
                                    user={this.props.user}
                                />
                            </Card >
                        </div >}
                {this.state.associatedCommunity && <ChangeAccountableConfirmationModal
                    open={this.state.openChangeAccountableConfirmationModal}
                    close={this.closeChangeAccountConfirmationModal}
                    associatedCommunity={this.state.associatedCommunity}
                    managers={this.state.managers}
                    members={this.state.members}
                    newAssignee={this.state.newAssignee}
                    teamId={this.props.selectedDataById.teamId}
                    selectedOrganisation={this.props.selectedOrganisation}
                    initiativeId={this.props.match.params.initiativeId}
                    stopProcessing={this.props.stopProcessing}
                    initiativeStatus={this.props.selectedDataById.status} />}
            </div>
        );
    }
}

export default withRouter(Team);